import { AnyAction } from 'redux';

const GET_ROW_DETAIL = 'GET_ROW_DETAIL';

const intialState = { data: [] };

export async function setRowDetail(dispatch: any, rowDetail: any) {
  dispatch({
    type: GET_ROW_DETAIL,
    data: rowDetail
  });
}

export const rowReducer = (state = intialState, action: AnyAction) => {
  switch (action.type) {
    case GET_ROW_DETAIL: {
      return {
        ...state,
        data: action.data
      };
    }
    default:
      return state;
  }
};